import { ExtensionFactory } from 'joi'

export const create = (): ExtensionFactory => joi => ({
  type: 'number',
  base: joi.number().unsafe(),
})
